import { StudentNoteFilter } from './student-note-filter';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Student } from '../../shared-components/student/student.model';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { UserPermission } from '../../shared-components/user/user-permission.model';
import { UserService } from '../../shared-components/user/user.service';
import { GeneralPreferences } from '../../shared-components/user-preferences/general-preferences.model';
import { UserPreferencesService } from '../../shared-components/user-preferences/user-preferences.service';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { StudentNotesService } from './student-notes.service';
import {
    Component,
    OnInit,
    OnDestroy,
    EventEmitter,
    ViewChild,
    AfterViewInit,
    TemplateRef,
    ElementRef,
    ChangeDetectorRef,
} from '@angular/core';
import { StudentNote } from './student-note.model';
import { StudentNoteCategory } from './student-note-category.model';
import { YearService } from '../../shared-components/year/year.service';
import { System } from '../../shared-components/System';
import { SharedService } from '../../shared-components/shared.service';
import { StudentSearchComponent } from '../../shared-components/student-search/student-search.component';
import { AddEditNoteDialogComponent } from './add-edit-note-dialog/add-edit-note-dialog.component';
import { DeleteNoteDialogComponent } from './delete-note-dialog/delete-note-dialog.component';
import { NoCategoriesWarningDialogComponent } from './no-categories-warning-dialog/no-categories-warning-dialog.component';
import { HasErrors } from '../../shared-components/guards/check-for-errors/HasErrors';
import { ErrorList } from '../../shared-components/controls/error-prompt/error-list.model';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { StudentService } from '../../shared-components/student/student.service';
import { StudentInformationComponent } from '../../shared-components/student-information/student-information.component';
import { Subscription } from 'rxjs';
import { TylCheckboxComponent } from '../../shared-components/controls/tyl-checkbox/tyl-checkbox.component';
import { LoginService } from '../../shared-modules/login/login.service';
import { PermissionEnum } from '../../shared-components/security/permissions.enums';
import { FilterModel } from '../../shared-components/controls/filter/filter.model';

@Component({
    selector: 'student-notes',
    templateUrl: './student-notes.component.html',
    styleUrls: [
        './student-notes.component.css'
    ],
    animations: [
        detailExpand
    ]
})
export class StudentNotesComponent implements OnInit, AfterViewInit, OnDestroy, HasErrors {

    // Properties
    private studentFilters: Student[] = [];
    private previousStudentFilters: Student[] = [];
    private selectedStudent: Student;
    private _sort: MatSort;

    errors: ErrorList[] = [];
    studentNotes: StudentNote[];
    displayedStudentNotes: StudentNote[] = [];
    categories: StudentNoteCategory[] = [];
    toggleExpandRows = new EventEmitter<boolean>();
    tableData = new TylerMatTableDataSource();
    columns = [
        'more',
        'student',
        'studentNumber',
        'category',
        'note',
        'order',
        'status',
        'start-date',
        'end-date',
        'display-as-bold',
        'classroom-note',
        'actions'
    ];
    columnWidths: { [key: string]: number } = {
        'more': 70,
        'actions': 70,
        'student': 150,
        'note': 400,
        'start-date': 135,
        'end-date': 135,
        'status': 90,
        'order': 90,
        'category': 105,
        'display-as-bold': 100,
        'classroom-note': 130,
        'studentNumber': 100
    };
    selectedRow: StudentNote;
    generalPreferences: GeneralPreferences;
    userPermissions: UserPermission[];
    userCanEditNotes = false;
    tableHeight: number;
    minTableWidth: number;
    numberMask: (rawValue: string) => {};
    showFilter = false;
    filter = new StudentNoteFilter();
    previousFilter = new StudentNoteFilter();
    StudentInfoDialog: MatDialogRef<StudentInformationComponent>;
    subscriptions: Subscription[] = [];
    studentPortal = false;
    loading = false;
    v10: boolean;

    // View Properties
    @ViewChild('pusherFilter', { read: TemplateRef }) pusherFilter: TemplateRef<any>;
    @ViewChild('formRef', { read: NgForm, static: true }) formRef: NgForm;
    @ViewChild('categoryField', { read: ElementRef }) categoryField: ElementRef;
    @ViewChild('noteField', { read: ElementRef }) noteField: ElementRef;
    @ViewChild('orderField', { read: ElementRef }) orderField: ElementRef;
    @ViewChild('statusField', { read: ElementRef }) statusField: ElementRef;
    @ViewChild('startDateField', { read: ElementRef }) startDateField: ElementRef;
    @ViewChild('endDateField', { read: ElementRef }) endDateField: ElementRef;
    @ViewChild('displayBoldCheckbox', { read: TylCheckboxComponent }) displayAsBoldCheckbox: TylCheckboxComponent;
    @ViewChild('classroomNoteCheckbox', { read: TylCheckboxComponent }) classroomNoteCheckbox: TylCheckboxComponent;
    private _paginator: MatPaginator;
    @ViewChild(MatPaginator, { static: true }) set paginator(value: MatPaginator) {
        this._paginator = value;
        this.tableData.paginator = value;
    }
    // Class Functions
    constructor(
        private studentNotesService: StudentNotesService,
        private yearService: YearService,
        private userPreferencesService: UserPreferencesService,
        private userService: UserService,
        private sharedService: SharedService,
        private dialog: MatDialog,
        private studentService: StudentService,
        private route: ActivatedRoute,
        private loginService: LoginService,
        private changeDetector: ChangeDetectorRef
    ) { }

    get filteringStudents(): boolean {
        return this.studentFilters.length > 0 && !!this.selectedStudent;
    }

    get filtering(): boolean {
        return this.filteringStudents ||
            (
                !System.isEqual(this.filter, new StudentNoteFilter())
                && (this.filter.startDateFrom ? this.filter.startDateFrom.toString() != 'Invalid Date' : true)
                && (this.filter.startDateTo ? this.filter.startDateTo.toString() != 'Invalid Date' : true)
                && (this.filter.endDateFrom ? this.filter.endDateFrom.toString() != 'Invalid Date' : true)
                && (this.filter.endDateTo ? this.filter.endDateTo.toString() != 'Invalid Date' : true)
            );
    }

    get sort(): MatSort {
        return this._sort;
    }

    @ViewChild(MatSort) set sort(value: MatSort) {
        this._sort = value;
        this.tableData.sort = this.sort;
    }

    // Event Functions
    ngOnInit() {
        // POST: initializes the data
        if (this.sharedService.currentPortal != undefined) {
            this.sharedService.currentPortal.applyFilterStudents = true;
        }
        this.v10 = this.loginService.LoginSettings.V10;

        // Marking this as loading
        this.loading = true;

        // Setting the initial values
        this.generalPreferences = this.userPreferencesService.generalPreferences;
        this.numberMask = System.numberMask;

        if (!this.generalPreferences.ShowStudentNumber) {
            this.removeElement(this.columns, 'studentNumber');
        }

        // Performing subscriptions
        this.subscriptions.push(
            this.route.queryParamMap.subscribe(params => {
                this.studentPortal = params.get('studentPortal') == 'true';
                if (this.studentPortal) {
                    if (this.studentService.selectedStudent) {
                        this.previousStudentFilters = [this.studentService.selectedStudent];
                        // this.studentFilters = [this.studentService.selectedStudent];
                        this.studentFilters = this.studentService.students;
                        this.selectedStudent = this.studentService.selectedStudent;
                    } else {
                        this.previousStudentFilters = [];
                        this.studentFilters = [];
                        this.selectedStudent = null;
                    }
                }

                // If we aren't filtering students, remove the student in focus
                else {
                    if (this.userService.selectedStudentInfoPortal != 'Student Notes') {
                        this.studentService.selectedStudent = null;
                        this.studentService.updateSelectedStudent(null);
                    }
                    else {
                        this.previousStudentFilters = [this.studentService.selectedStudent];
                        this.studentFilters = this.studentService.students;
                        this.selectedStudent = this.studentService.selectedStudent;
                    }
                }

                // Arranging the table data after we've configured initial filters
                this.arrangeTableData();
            }),
            this.yearService.observableDefaultYearStream$.subscribe(() => {
                this.getStudentNotes();
                this.getPermissions();
            }),
            this.toggleExpandRows.subscribe(expand => {
                this.tableData.expandAll(expand);
            }),
            // this.studentService.observableStudentsStream$.subscribe(students => {
            // 	if (students && (!this.loading || this.studentPortal)) {
            // 		this.studentFilters = students;
            // 	}
            // }),
            this.studentService.selectedStudentStream$.subscribe(() => {
                if (!this.loading || this.studentPortal) {
                    this.previousStudentFilters = [this.studentService.selectedStudent];
                    // this.studentFilters = [this.studentService.selectedStudent];
                    this.studentFilters = this.studentService.students;
                    this.selectedStudent = this.studentService.selectedStudent;
                    this.arrangeTableData();
                }
            }),
            this.userPreferencesService.observablegeneralPreferencesStream$.subscribe(preferences => {
                this.generalPreferences = preferences;
                if (!this.generalPreferences.ShowStudentNumber) {
                    this.removeElement(this.columns, 'studentNumber');
                }
                else {
                    let index: number = this.columns.findIndex(column => column == 'studentNumber');
                    if (index == -1) {
                        index = this.columns.findIndex(column => column == 'student');
                        this.columns.splice(index + 1, 0, 'studentNumber');
                    }
                }
            })
        );
        this.getStudentNotes();
        this.getPermissions();

        // Setting the tables sort accessor
        this.tableData.sortingDataAccessor = (data: any, sortHeaderId: string): string | number => {
            // PRE: a sort or filter is called on a table
            // POST: returns the data for a cell for sorting
            const student = new Student();

            switch (sortHeaderId) {
                case 'studentNumber':
                    return student.StudentNumber;
                case 'student':
                    Object.assign(student, data);
                    return student.formattedNameWithNumber(this.generalPreferences);
                case 'category':
                    return data.category(this.categories).Code;
                case 'display-as-bold':
                    if (data['DisplayBold']) {
                        return 'Y';
                    } else {
                        return '';
                    }
                case 'classroom-note':
                    if (data['ClassroomNote']) {
                        return 'Y';
                    } else {
                        return '';
                    }
                default:
                    return this.tableData.defaultSortingAccessor(data, sortHeaderId);
            }
        };

        // Marking this as not loading
        this.loading = false;
    }

    ngAfterViewInit() {
        // POST: sets the table height
        this.resize();
    }

    ngOnDestroy() {
        // NOTE: implemented for @AutoUnsubscribe
        if (this.sharedService.currentPortal != undefined) {
            this.sharedService.currentPortal.applyFilterStudents = false;
        }
    }

    studentChange(studentId: number) {
        // PRE: the student is changed in the header
        // POST: changes the selected student and applies the filter

    }

    checkErrors(nextState?: RouterStateSnapshot): number {
        // PRE: the user tries to navigate away
        // POST: checks the errors.
        //      If 4, shows the warning dialog. If the result is true, it will wait for the save before it continues.
        //      If 3, shows the warning, but doesn't perform route on the save (lets the component do it)
        //      If 2, continues without save.
        //      If 1, continues with save.
        //      If 0, shows warning.
        //      If -1, stops.
        this.validate();
        if (this.formRef) {
            if (this.formRef.pristine && this.errors.length == 0) {
                return 2;
            } else {
                return 0;
            }
        }
        return 1;
    }

    save(): any {
        // PRE: the data has been validated and there is no errors
        // POST: performs a save on route
        this.studentNotesService.updateStudentNotes(this.displayedStudentNotes).subscribe(
            () => {
                this.sharedService.showGoodSnackbar();
                this.formRef.form.markAsPristine();
                this.selectedRow = null;
            },
            () => {
                this.sharedService.showBadSnackbar();
                this.selectedRow = null;
            }
        );
    }

    saveClick() {
        // PRE: the save button is clicked
        // POST: validates and then performs save
        this.validate();
        if (this.errors.length == 0) {
            this.save();
        }
    }

    showFilterClick() {
        // PRE: the filter button from the footer notification or the footer itself is clicked
        // POST: opens the filter menu
        this.showFilter = !this.showFilter;
    }

    clearFilter() {
        // PRE: the clear filter button is clicked
        // POST: clears the filter but does not close it
        setTimeout(() => {
            Object.assign(this.filter, new StudentNoteFilter());
            this.studentService.students = [];
            this.studentService.updateSelectedStudent(null);
            // Detecting page changes to deal with ExpressionChanged errors
            this.changeDetector.detectChanges();
        }, 0);
    }

    clearFilterFromFooter() {
        // PRE: the clear filter button on the footer notification is clicked
        // POST: clears the filter and saves it
        setTimeout(() => {
            Object.assign(this.filter, new StudentNoteFilter());
            this.studentService.students = [];
            this.studentService.updateSelectedStudent(null);
            Object.assign(this.previousFilter, this.filter);
            this.previousStudentFilters = JSON.parse(JSON.stringify(this.studentFilters));
            this.tableData.removeAllFilters();
            // Detecting page changes to deal with ExpressionChanged errors
            this.changeDetector.detectChanges();
        }, 0);
    }

    cancelFilter() {
        this.showFilterClick();
    }

    studentSearchFilter() {
        // PRE: the search for students filter button is clicked
        // POST: opens the student search for multiselect to filter the students
        const dialogBox = this.dialog.open(StudentSearchComponent, {
            data: {
                selectedStudents: this.studentFilters,
                searchAndSelect: true,
                returnSelectedStudents: true,
                schools: this.studentNotesService.viewSchools,
                useLastSelectedSchool: false
            },
            disableClose: true,
            width: '100%',
            height: '100%',
            maxHeight: '100vh',
            maxWidth: '100vw'
        });
        dialogBox.afterClosed().subscribe((selectedStudents: Student[]) => {
            if (selectedStudents && selectedStudents.length > 0) {
                this.studentService.updateStudents(selectedStudents);
            }
        });
    }

    clearStudentSearchFilter() {
        // PRE: the clear student search filter button is clicked
        // POST: removes all the students from the student filter array
        this.studentService.students = [];
        this.studentService.updateSelectedStudent(null);
        // Detecting page changes to deal with ExpressionChanged errors
        this.changeDetector.detectChanges();
    }

    massAdd() {
        // PRE: the mass add button is clicked
        // POST: opens the mass add dialog
        let dialogBox: MatDialogRef<any, any> = this.dialog.open(StudentSearchComponent, {
            disableClose: true,
            width: '100%',
            height: '100%',
            maxHeight: '100vh',
            maxWidth: '100vw',
            data: {
                searchAndSelect: true,
                acceptLabel: 'Continue',
                schools: this.studentNotesService.addEditSchools,
                useLastSelectedSchool: false
            }
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(students => {
                if (students && students.length > 0) {
                    dialogBox = this.dialog.open(AddEditNoteDialogComponent, {
                        disableClose: true,
                        data: {
                            categories: this.categories,
                            multiAdd: true,
                            multiStudents: students
                        }
                    });
                    this.subscriptions.push(
                        dialogBox.afterClosed().subscribe(newNotes => {
                            if (newNotes) {
                                this.getStudentNotes();
                            }
                        })
                    );
                }
            })
        );
    }

    cellClick(note: StudentNote, cellName: string) {
        // PRE: a cell is clicked
        // POST: toggles that row's fields and sets the focused one to the right input

        // We only focus fields if the user can edit notes
        if (!this.userCanEditNotes) {
            return;
        }

        // This toggles the rows fields
        this.selectedRow = note;

        // Once the change detection creates the fields, focus the proper one
        setTimeout(() => {
            switch (cellName) {
                case 'category':
                    this.categoryField.nativeElement.focus();
                    break;
                case 'note':
                    this.noteField.nativeElement.focus();
                    break;
                case 'order':
                    this.orderField.nativeElement.focus();
                    break;
                case 'status':
                    this.statusField.nativeElement.focus();
                    break;
                case 'startDate':
                    this.startDateField.nativeElement.focus();
                    break;
                case 'endDate':
                    this.endDateField.nativeElement.focus();
                    break;
                case 'displayAsBold':
                    this.displayAsBoldCheckbox.focus();
                    break;
                case 'classroomNote':
                    this.classroomNoteCheckbox.focus();
                    break;
                default:
                    break;
            }
        }, 0);
    }

    // Methods
    resize() {
        // POST: sets the table width
        setTimeout(() => {

            // Determining the minimum table width of the grid
            this.minTableWidth = 0;
            for (let i = 0; i < this.columns.length; i++) {
                if (this.columnWidths[this.columns[i]]) {
                    this.minTableWidth += this.columnWidths[this.columns[i]];
                }
            }
        }, 0);
    }

    getStudentNotes() {
        // POST: obtains the student notes and student notes categories from the server

        // Obtaining student notes
        const noteSubscription = this.studentNotesService.getStudentNotes().subscribe(studentNotes => {

            // Performing conversions
            this.studentNotes = studentNotes;
            for (let i = 0; i < this.studentNotes.length; i++) {
                this.studentNotes[i] = System.convert<StudentNote>(this.studentNotes[i], new StudentNote());
                this.studentNotes[i].clearJunkDates();
            }

            // Arranging table data
            this.arrangeTableData();
            // Detecting page changes to deal with ExpressionChanged errors
            this.changeDetector.detectChanges();
        });

        // Obtaining student note categories
        this.studentNotesService.getStudentNotesCategories().subscribe(categories => {
            this.categories = categories;
            if (!this.categories || this.categories.length == 0) {
                noteSubscription.unsubscribe();
                this.dialog.open(NoCategoriesWarningDialogComponent, {
                    disableClose: true
                });
            }
        });
    }

    arrangeTableData() {
        // POST: filters through the data for the students searched for and then sets the table data
        if (!this.studentNotes) {
            return;
        }
        this.tableData.cacheExpanded();
        this.displayedStudentNotes = this.studentNotes;

        // Student Number Filter
        if (this.filter.studentNumber) {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.StudentNumber.includes(this.filter.studentNumber)
            );
        }

        // Student Filter
        if (this.studentFilters.length > 0 && this.selectedStudent) {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.StudentID == this.selectedStudent.Id
            );
        }

        // Category Filter
        if (this.filter.category) {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.category(this.categories).Code.toLowerCase().includes(this.filter.category)
            );
        }

        // Note Filter
        if (this.filter.note) {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.Note.toLowerCase().includes(this.filter.note.toLowerCase())
            );
        }

        // Status Filter
        if (this.filter.status) {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.Status.toLowerCase().includes(this.filter.status.toLowerCase())
            );
        }

        // Start Date From
        if (this.filter.startDateFrom && this.filter.startDateFrom.toString() != 'Invalid Date') {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.StartDate >= this.filter.startDateFrom
            );
        }

        // Start Date To
        if (this.filter.startDateTo && this.filter.startDateTo.toString() != 'Invalid Date') {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.StartDate <= this.filter.startDateTo
            );
        }

        // End Date From
        if (this.filter.endDateFrom && this.filter.endDateFrom.toString() != 'Invalid Date') {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.EndDate >= this.filter.endDateFrom
            );
        }

        // End Date To
        if (this.filter.endDateTo && this.filter.endDateTo.toString() != 'Invalid Date') {
            this.displayedStudentNotes = this.displayedStudentNotes.filter(note =>
                note.EndDate <= this.filter.endDateTo
            );
        }

        // Setting table data
        this.tableData.data = this.displayedStudentNotes;
        this.tableData.assertCachedExpanded('Id');
        this.resize();
    }

    addNote() {
        // POST: opens the add modal
        const note = new StudentNote();
        note.clearJunkDates();
        let clicked = false;

        // Helper function for clicking on a student
        const assignStudent = (student) => {
            note.StudentID = student.Id;
            note.StudentNumber = student.StudentNumber;
            note.FirstName = student.FirstName;
            note.MiddleName = student.MiddleName;
            note.LastName = student.LastName;
            note.Nickname = student.NickName;
        };
        const clickHandler = (event) => {
            assignStudent(event.row);
            clicked = true;
        };

        // Helper function to open add/edit note
        const openAddEdit = () => {
            const dialogBox2 = this.dialog.open(AddEditNoteDialogComponent, {
                data: {
                    addNote: true,
                    categories: this.categories,
                    note: note
                }
            });
            dialogBox2.afterClosed().subscribe(newNote => {
                if (newNote) {
                    this.getStudentNotes();
                }
            });
        };

        // If we have a selected student, opens the add/edit with that student
        if (this.selectedStudent && this.filteringStudents) {
            assignStudent(this.selectedStudent);
            openAddEdit();
        } else {
            const dialogBox = this.dialog.open(StudentSearchComponent, {
                data: {
                    performRoute: false,
                    clickHandler: clickHandler,
                    schools: this.studentNotesService.addEditSchools,
                    useLastSelectedSchool: false
                },
                disableClose: true,
                width: '100%',
                height: '100%',
                maxHeight: '100vh',
                maxWidth: '100vw'
            });
            dialogBox.afterClosed().subscribe(() => {
                if (clicked) {
                    openAddEdit();
                }
            });
        }
    }

    editNote(note: StudentNote) {
        // POST: opens the edit modal for a note
        this.dialog.open(AddEditNoteDialogComponent, {
            data: {
                addNote: false,
                categories: this.categories,
                note: note
            }
        });
    }

    deleteNote(note: StudentNote) {
        // POST: opens the delete modal for a note
        const dialogBox = this.dialog.open(DeleteNoteDialogComponent, {
            data: {
                note: note
            }
        });
        dialogBox.afterClosed().subscribe(deleted => {
            if (deleted) {
                this.studentNotes.splice(this.studentNotes.indexOf(note), 1);
                this.arrangeTableData();
            }
        });
    }

    viewStudent(note: StudentNote) {
        this.studentService.getStudent(note.StudentID).subscribe((studentData) => {
            const studentRecord = { Id: note.StudentID, FirstName: note.FirstName, LastName: note.LastName, MiddleName: note.MiddleName, NickName: note.Nickname, Picture: studentData.Picture };
            const studentRecords = [studentRecord];
            this.displayedStudentNotes.forEach(student => {
                if (studentRecords.findIndex(record => record.Id == student.StudentID) == -1) {
                    studentRecords.push({
                        Id: student.StudentID,
                        FirstName: student.FirstName,
                        LastName: student.LastName,
                        MiddleName: student.MiddleName,
                        NickName: student.Nickname,
                        Picture: undefined
                    });
                }
            });
            this.StudentInfoDialog = this.dialog.open(StudentInformationComponent, { panelClass: 'tyl-mat-dialog', disableClose: true, height: '100%', position: { top: '0px', right: '0px' } });
            this.StudentInfoDialog.componentInstance.student = studentRecord;
            this.StudentInfoDialog.componentInstance.students = studentRecords;
            this.StudentInfoDialog.componentInstance.initMenu();
        });
    }

    validate() {
        // POSt: sets the errors

        // Resetting the errors
        this.errors = [];

        // Checking each displayed note
        for (let i = 0; i < this.displayedStudentNotes.length; i++) {
            const note = this.displayedStudentNotes[i];

            // Note is required
            if (!note.Note) {
                this.errors.push({
                    fieldRef: null,
                    fieldName: 'Note',
                    errorMsg: 'Field is required.',
                    clickCallback: () => {
                        this.cellClick(note, 'note');
                    }
                });
            }

            // Order is required
            if (!note.Order) {
                this.errors.push({
                    fieldRef: null,
                    fieldName: 'Order',
                    errorMsg: 'Field is required.',
                    clickCallback: () => {
                        this.cellClick(note, 'order');
                    }
                });
            }

            // Order must be a number
            if (typeof note.Order != 'number') {

                // Correcting for string entries
                if (Number.parseInt(note.Order, 10)) {
                    note.Order = Number.parseInt(note.Order, 10);
                }

                // Catching error if it's a word
                else {
                    this.errors.push({
                        fieldRef: null,
                        fieldName: 'Order',
                        errorMsg: 'Value must be a number.',
                        clickCallback: () => {
                            this.cellClick(note, 'order');
                        }
                    });
                }
            }

            // Status is required
            if (!note.Status) {
                this.errors.push({
                    fieldRef: null,
                    fieldName: 'Status',
                    errorMsg: 'Field is required.',
                    clickCallback: () => {
                        this.cellClick(note, 'status');
                    }
                });
            }

            // End date must be after start date
            if (note.StartDate && note.EndDate && note.EndDate < note.StartDate) {
                this.errors.push({
                    fieldRef: null,
                    fieldName: 'Dates',
                    errorMsg: 'The End Date must be on or after the Start Date.',
                    clickCallback: () => {
                        this.cellClick(note, 'startDate');
                    }
                });
            }
        }
    }

    getPermissions() {
        if (this.v10) {
            // POST: getting the user permissions and the schols they have access to
            this.subscriptions.push(
                // Getting the schools the user has access to for student notes
                this.userService.getUserPermissionByPrivilegeIds(
                    this.yearService.defaultYear.Id,
                    0,  // We do this to get all sites
                    [
                        PermissionEnum.StudentNotesCounselorAddEdit,
                        PermissionEnum.StudentNotesCounselorView,
                        PermissionEnum.StudentNotesMyStudentsAddEdit,
                        PermissionEnum.StudentNotesMyStudentsView,
                        PermissionEnum.StudentNotesStudentRecordAddEdit,
                        PermissionEnum.StudentNotesStudentRecordView
                    ]
                ).subscribe(permissions => {
                    this.studentNotesService.addEditSchools = [];
                    this.studentNotesService.viewSchools = [];
                    permissions.forEach(permission => {
                        const school = this.yearService.allDistrictSchools.find(s => s.Id == permission.SiteId);
                        if (school) {
                            if (!this.studentNotesService.viewSchools.includes(school)) {
                                this.studentNotesService.viewSchools.push(school);
                            }
                            if (permission.PrivilegeId == PermissionEnum.StudentNotesCounselorAddEdit
                                || permission.PrivilegeId == PermissionEnum.StudentNotesMyStudentsAddEdit
                                || permission.PrivilegeId == PermissionEnum.StudentNotesStudentRecordAddEdit) {
                                if (!this.studentNotesService.addEditSchools.includes(school)) {
                                    this.studentNotesService.addEditSchools.push(school);
                                }
                            }
                        }
                    });

                    this.userPermissions = permissions.filter(o => o.SiteId == this.yearService.defaultYear.SchoolID);

                    // Determining if the user can edit notes
                    if (this.userPermissions.find(permission => permission.PermissionName == 'Add/Edit Student Notes')) {
                        this.userCanEditNotes = true;
                    } else {
                        this.userCanEditNotes = false;
                    }

                    // Determining which columns should display based on that
                    if (this.userCanEditNotes && !this.columns.includes('actions')) {
                        this.columns.push('actions');
                    } else if (!this.userCanEditNotes && this.columns.includes('actions')) {
                        this.columns.splice(this.columns.indexOf('actions'), 1);
                    }

                    // Determining the width of the table with the new information
                    this.resize();
                })


            );
        }
        else {
            // POST: getting the user permissions they have access to
            (
                this.userService.getUserPermissions(
                    this.yearService.defaultYear.Id,
                    this.yearService.defaultYear.SchoolID
                ).subscribe(permissions => {
                    this.userPermissions = permissions;
                    // Determining if the user can edit notes
                    if (this.userPermissions.find(permission => permission.PermissionName == 'Maintain Student Notes')) {
                        this.userCanEditNotes = true;
                    } else {
                        this.userCanEditNotes = false;
                    }

                    // Determining which columns should display based on that
                    if (this.userCanEditNotes && !this.columns.includes('actions')) {
                        this.columns.push('actions');
                    } else if (!this.userCanEditNotes && this.columns.includes('actions')) {
                        this.columns.splice(this.columns.indexOf('actions'), 1);
                    }

                    // Determining the width of the table with the new information
                    this.resize();
                }));
        }
    }

    removeElement(array: any[], element: any) {
        const index: number = array.indexOf(element);
        if (index != -1) {
            array.splice(index, 1);
        }
    }
    headerFilterChanged(column: string) {
        const row = this.tableData.filters.find(o => o.column == column);
        if (column == 'Status') {
            this.tableData.removeFilter(row);
            if (row.operator == '1') {
                this.tableData.data = this.displayedStudentNotes.filter(o => o.Status == 'Active');
                this.tableData.addFilter(new FilterModel('Active', column, '1', 'string', undefined), this.tableData);
            }
            else if (row.operator == '2') {
                this.tableData.data = this.displayedStudentNotes.filter(o => o.Status == 'Inactive');
                this.tableData.addFilter(new FilterModel('Inactive', column, '2', 'string', undefined), this.tableData);
            }
            else if (row.operator == '0') {
                this.tableData.data = this.displayedStudentNotes;
                this.tableData.addFilter(new FilterModel('', column, '0', 'boolean', undefined), this.tableData);
            }
        }
        // Detecting page changes to deal with ExpressionChanged errors
        this.changeDetector.detectChanges();
    }

    continuedWithoutSave(): any {
    }
}
